import { graphql } from '@/generated/gql';

export const NEGOTIATION_TASK_RESOLVE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationTaskResolve($id: ID!) {
    resolveTask(id: $id) {
      id
      status
    }
  }
`);
